<template>
  <div>
    <!-- 위험등록부 목록 -->
    <c-table
      ref="table"
      title="LBL0001203"
      tableId="riskRegister01"
      :columns="gridRisk.columns"
      :data="riskReduce.riskbooks"
      :merge="gridRisk.merge"
      :gridHeight="setheight"
      :editable="editable && !disabled"
      selection="multiple"
      rowKey="ramSignificantRiskRegisterId"
      checkDisableColumn="riskRegisterFlag"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable && !disabled"
            label="LBLREMOVE"
            icon="remove"
            @btnClicked="removeRisk"
          />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'riskHazardPicture'">
          <q-icon
            class="cursor-pointer"
            size="sm"
            color="blue-6"
            name="image"
            @click.stop="openHazardPicture(props)"
          />
        </template>
        <template v-else-if="col.name === 'picture'">
          <q-icon
            class="cursor-pointer"
            size="sm"
            color="green"
            name="image"
            @click.stop="openImprPicture(props)"
          />
        </template>
        <template v-else-if="col.name === 'customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="false"
            :requestContentsCols="requestContentsCols"
            tableKey="ramKrasAssessScenarioId"
            ibmTaskTypeCd="ITT0000020"
            ibmTaskUnderTypeCd="ITTU000025"
            @imprChange="imprChange"
          />
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "kras-risk-register",
  props: {
    param: {
      type: Object,
      default: function () {
        return {
          ramRiskAssessmentPlanId: "",
          ramStepCd: "",
        };
      },
    },
    riskReduce: {
      type: Object,
      default: function () {
        return {
          imprs: [],
          riskbooks: [],
        };
      },
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      gridRisk: {
        merge: [
          { index: 0, colName: "processName" },
          { index: 1, colName: "groupMdmSopId" },
          { index: 2, colName: "riskHazardName" },
          { index: 3, colName: "riskHazardName" },
          { index: 4, colName: "riskHazardName" },
        ],
        columns: [
          {
            name: "processName",
            field: "processName",
            label: "LBLPROCESS",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "jobName",
            field: "jobName",
            label: "작업순서",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "riskHazardPicture",
            field: "riskHazardPicture",
            // 사진
            label: "LBL0001175",
            align: "center",
            style: "width:40px",
            sortable: false,
            type: "custom",
          },
          {
            name: "riskHazardName",
            field: "riskHazardName",
            // 분류-유해위험요인
            label: "LBL0001020",
            align: "left",
            style: "width:250px",
            sortable: false,
          },
          {
            name: "relationLaw",
            field: "relationLaw",
            // 관련법규
            label: "LBL0001021",
            align: "left",
            style: "width:100px",
            sortable: false,
          },
          {
            name: "riskOccurrenceCause",
            field: "riskOccurrenceCause",
            // 원인
            label: "LBL0001006",
            align: "left",
            style: "width:200px",
            sortable: false,
          },
          {
            name: "riskOccurrenceResult",
            field: "riskOccurrenceResult",
            // 결과
            label: "LBL0001007",
            align: "left",
            style: "width:200px",
            sortable: false,
          },
          {
            name: "currentSafetyMeasures",
            field: "currentSafetyMeasures",
            // 현재안전조치
            label: "LBL0001025",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "before",
            field: "before",
            // 개선전
            label: "LBL0001008",
            align: "center",
            child: [
              {
                name: "beforeFrequency",
                field: "beforeFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeStrength",
                field: "beforeStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "beforeRisk",
                field: "beforeRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: "picture",
            field: "picture",
            // 개선<br/>전/후<br/>사진
            label: "개선 전/후 사진",
            align: "center",
            type: "custom",
            style: "width:70px",
            sortable: false,
          },
          {
            name: "improvementMeasures",
            field: "improvementMeasures",
            // 추가 리스크관리 계획
            label: "LBL0001122",
            align: "left",
            style: "width:150px",
            sortable: false,
          },
          {
            name: "customCol",
            field: "customCol",
            label: "LBLIMPRNO_PROGRESS",
            align: "center",
            style: "width:150px",
            type: "custom",
            sortable: false,
          },
          {
            name: "after",
            field: "after",
            // 개선후
            label: "LBL0001012",
            align: "center",
            child: [
              {
                name: "afterFrequency",
                field: "afterFrequency",
                // 빈도
                label: "LBL0001009",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterStrength",
                field: "afterStrength",
                // 강도
                label: "LBL0001010",
                align: "center",
                style: "width:50px",
                sortable: false,
              },
              {
                name: "afterRisk",
                field: "afterRisk",
                // 위험도
                label: "LBL0001011",
                align: "center",
                style: "width:70px",
                sortable: false,
              },
            ],
          },
          {
            name: "assessDate",
            field: "assessDate",
            // 평가일
            label: "LBL0001013",
            align: "center",
            style: "width:90px",
            sortable: false,
          },
          {
            name: "assessUserName",
            field: "assessUserName",
            // 평가자
            label: "LBL0001014",
            align: "center",
            userId: "assessUserId",
            style: "width:80px",
            sortable: false,
          },
        ],
        data: [],
        height: "500px",
      },
      imprComponent: () => import(`${"@/pages/common/ibm/tableImpr.vue"}`),
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        width: "80%",
        param: {},
        closeCallback: null,
      },
      requestImprRow: null,
      editable: true,
      deleteUrl: "",
    };
  },
  computed: {
    setheight() {
      let pxRemove = this.height.replace("px", "");
      return this.height && this.height.indexOf("px") > -1 && !isNaN(pxRemove)
        ? Number(pxRemove) - 50 + "px"
        : "500px";
    },
    disabled() {
      return this.param.ramStepCd === "RRS0000015";
    },
    requestContentsCols() {
      return ["riskHazardNameClass", "riskOccurrenceCause"];
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.deleteUrl = this.$format(
        transactionConfig.ram.riskRegister.delete.url,
        "ITT0000020",
      );
      // code setting
      // list setting
    },
    research() {
      this.$emit("research");
    },
    imprChange() {
      this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
      this.research();
    },
    linkClick(data, row) {
      this.requestImprRow = row;
      this.popupOptions.title = "LBLIMPROVE";
      this.popupOptions.param = {
        sopImprovementId: data.sopImprovementId,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprDetail.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result, flag) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        if (flag !== "delete") {
          if (
            result.col1.ibmStepCd === "IS00000010" ||
            result.col1.ibmStepCd === "IS00000015" ||
            result.col1.ibmStepCd === "IS00000020"
          ) {
            this.requestImprRow.riskRegisterFlag = true;
          }
          let splitId = this.$_.split(
            this.requestImprRow.sopImprovementIds,
            ",",
          );
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ",");
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(
              splitId,
              result.col1.sopImprovementId,
            );
            splitStep[idIndex] = result.col1.ibmStepName;
            this.requestImprRow.ibmStepNames = splitStep.toString();
          }
        } else {
          let splitId = this.$_.split(
            this.requestImprRow.sopImprovementIds,
            ",",
          );
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ",");
          let splitClass = this.$_.split(this.requestImprRow.ibmClassCds, ",");
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(
              splitId,
              result.col1.sopImprovementId,
            );
            splitId.splice(idIndex, 1);
            splitStep.splice(idIndex, 1);
            splitClass.splice(idIndex, 1);
            this.$set(
              this.requestImprRow,
              "sopImprovementIds",
              splitId.toString(),
            );
            this.$set(
              this.requestImprRow,
              "ibmStepNames",
              splitStep.toString(),
            );
            this.$set(
              this.requestImprRow,
              "ibmClassCds",
              splitClass.toString(),
            );
          }
        }
        this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
        this.research();
      }
    },
    /* eslint-disable no-unused-vars */
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row;
      let requestContents = props.row.riskHazardName;
      if (props.row.riskOccurrenceCause) {
        requestContents += " / " + props.row.riskOccurrenceCause;
      }
      this.popupOptions.title = "LBLIMPRREQUEST";
      this.popupOptions.param = {
        requestContents: requestContents,
        relationTableKey: props.row.ramKrasAssessScenarioId,
        ibmTaskTypeCd: "ITT0000020",
        ibmTaskUnderTypeCd: "ITTU000025",
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/ibm/imprRequest.vue"}`);
      this.popupOptions.width = "80%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, (item) => {
          let sData = this.requestImprRow.sopImprovementIds
            ? this.requestImprRow.sopImprovementIds
            : "";
          if (sData.indexOf(item.sopImprovementId) === -1) {
            this.requestImprRow.sopImprovementIds = this.requestImprRow
              .sopImprovementIds
              ? this.requestImprRow.sopImprovementIds +
                "," +
                item.sopImprovementId
              : item.sopImprovementId;
            this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames
              ? this.requestImprRow.ibmStepNames + "," + item.ibmStepName
              : item.ibmStepName;
            this.requestImprRow.ibmClassCds = this.requestImprRow.ibmClassCds
              ? this.requestImprRow.ibmClassCds + "," + item.ibmClassCd
              : item.ibmClassCd;
            this.requestImprRow.ibmTooltip = this.requestImprRow.ibmTooltip
              ? this.requestImprRow.ibmTooltip + "│" + item.ibmTooltip
              : item.ibmTooltip;
          }
        });
        this.$refs["table"].$refs["compo-table"].resetVirtualScroll();
        this.research();
      }
    },
    removeRisk() {
      let selectData = this.$refs["table"].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit("ALERT", {
          title: "LBLGUIDE", // 안내
          message: "MSGNOITEMS", // 선택된 항목이 없습니다.
          type: "warning", // success / info / warning / error
        });
      } else {
        window.getApp.$emit("CONFIRM", {
          title: "LBLCONFIRM",
          message: "MSGREMOVE", // 삭제하시겠습니까?,
          // TODO : 필요시 추가하세요.
          type: "info", // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            let deleteData = [];
            this.$_.forEach(selectData, (item) => {
              deleteData.push({
                ramSignificantRiskRegisterId: item.ramSignificantRiskRegisterId,
                ramRiskAssessmentPlanId: item.ramRiskAssessmentPlanId,
                processCd: item.processCd,
                scenarioId: item.ramKrasAssessScenarioId,
              });
            });
            this.$http.url = this.deleteUrl;
            this.$http.type = "DELETE";
            this.$http.param = {
              data: Object.values(deleteData),
            };
            this.$http.request(() => {
              window.getApp.$emit("APP_REQUEST_SUCCESS");
              this.$_.forEach(selectData, (item) => {
                this.riskReduce.riskbooks.splice(
                  this.$_.findIndex(this.riskReduce.riskbooks, {
                    ramSignificantRiskRegisterId:
                      item.ramSignificantRiskRegisterId,
                  }),
                  1,
                );
              });
              this.$refs["table"].$refs["compo-table"].clearSelection();
              this.research();
            });
          },
          // 취소 callback 함수
          cancelCallback: () => {},
        });
      }
    },
    openHazardPicture(props) {
      this.popupOptions.title = "LBL0001110"; // 유해위험요인 사진
      this.popupOptions.param = {
        ramRiskHazardId: props.row.ramRiskHazardId,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/common/hazard/riskHazardPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPicturePopup;
    },
    closeHazardPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    openImprPicture(props) {
      this.popupOptions.title = "LBL0001181"; // 개선 사진
      this.popupOptions.param = {
        ramKrasAssessScenarioId: props.row.ramKrasAssessScenarioId,
        sopImprovementIds: props.row.sopImprovementIds,
        disabled: true,
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/ram/kras/action/krasScenarioImprPicture.vue"}`);
      this.popupOptions.width = "30%";
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeScenarioImprPicturePopup;
    },
    closeScenarioImprPicturePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
  },
};
</script>
